import { Badge } from '@mantine/core';
import {
  HighwayMaintenanceFeePenaltyTicketState,
  HIGHWAY_MAINTENANCE_FEE_PENALTY_TICKET_STATE_POLICY,
} from '../model';

const STATE_BADGE_COLOR: Record<
  HighwayMaintenanceFeePenaltyTicketState,
  string
> = {
  [HighwayMaintenanceFeePenaltyTicketState.PENDING]: 'yellow',
  [HighwayMaintenanceFeePenaltyTicketState.NO_FEE]: 'gray',
  [HighwayMaintenanceFeePenaltyTicketState.QUERY_FAILED]: 'red',
  [HighwayMaintenanceFeePenaltyTicketState.CHARGING]: 'blue',
  [HighwayMaintenanceFeePenaltyTicketState.CHARGE_FAILED]: 'orange',
  [HighwayMaintenanceFeePenaltyTicketState.CHARGE_SUCCESS]: 'green',
  [HighwayMaintenanceFeePenaltyTicketState.COMPLETED]: 'teal',
};

export const HighwayMaintenanceFeePenaltyStateBadge = ({
  state,
}: {
  state: HighwayMaintenanceFeePenaltyTicketState;
}) => (
  <Badge color={STATE_BADGE_COLOR[state]} variant="light" size="lg">
    {HIGHWAY_MAINTENANCE_FEE_PENALTY_TICKET_STATE_POLICY[state].text}
  </Badge>
);
